import { Tooltip } from '@chakra-ui/react';

import { useNextTranslation } from '@/i18n/client';

import styles from './styles.module.scss';
interface ActivityCountProps {
  createdActivities: number;
  approvedActivities: number;
}

const ACTIVITY_NUMBER_THRESHOLD = 1_000_000;

function formatActivityNumber(value: number, threshold = ACTIVITY_NUMBER_THRESHOLD): string {
  if (value > threshold) {
    return `${threshold.toLocaleString()}+`;
  }
  return value.toLocaleString();
}

export default function ActivityCount({ createdActivities = 0, approvedActivities = 0 }: ActivityCountProps) {
  const { t } = useNextTranslation();
  const isAnyOver1M = createdActivities > ACTIVITY_NUMBER_THRESHOLD || approvedActivities > ACTIVITY_NUMBER_THRESHOLD;
  const labelApproved = t('common.status-APPROVED');
  const labelCreated = t('common.status-CREATED');
  return (
    <Tooltip
      label={
        <>
          {labelApproved}: {approvedActivities.toLocaleString()}
          <br />
          {labelCreated}: {createdActivities.toLocaleString()}
        </>
      }
      bg={'gray.900'}
      borderRadius={4}
      hasArrow
      isDisabled={!isAnyOver1M}
    >
      <div className={styles['activity-container']}>
        <div className={styles['approved-activity']}>{labelApproved}：</div>
        <div className={styles['approved-activity']} data-testid='approved-activities'>
          {formatActivityNumber(approvedActivities)}
        </div>
        <div className={styles['created-activity']}>{labelCreated}：</div>
        <div className={styles['created-activity']} data-testid='create-activities'>
          {formatActivityNumber(createdActivities)}
        </div>
      </div>
    </Tooltip>
  );
}
